<template>
    <div class="container">
        <div class="welcome">
            <span>
                Benvenuti
            </span>
        </div>
        <b-container fluid>
            <b-row>
                <b-col class="left-column">
                    <router-link to="/login-studio">
                        <div class="card">
                            <span class="card-title">
                                Accesso Studio Dentistico
                            </span>
                            <img alt="Studio Dentistico" src="../assets/tooth-primary.svg" class="card-img"/>
                        </div>
                    </router-link>
                </b-col>
                <b-col class="right-column">
                    <router-link to="/login-lab">
                        <div class="card">
                            <span class="card-title">
                                Accesso Laboratori
                            </span>
                            <img alt="Laboratori" src="../assets/lab-primary.svg" class="card-img"/>
                        </div>
                    </router-link>
                </b-col>
            </b-row>
        </b-container>
        
    </div>
</template>

<script>
export default {
    name: "LoginCards"
}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
        text-align: left;
        padding-top: 90px;
    }
    .welcome{
        font-size: 23px;
        /* color: #c6c6c6; */
        font-weight: bold;
        padding-bottom: 50px;
    }
    .left-column{        
        padding: 0;
    }
    .right-column{
        padding: 0;
        text-align: right;
    }
    .card{
        width: 90%;
        display: inline-flex;
        height: 350px;
        box-shadow: 0 0 5px #6abf61;
        padding: 60px 30px;
        text-align: center;
        align-items: center;
    }
    .card-title{
        font-size: 21px;
        font-weight: bold;
        color: #707070;
    }
    .card-img{
        padding-top:40px;
        width:150px;
    }
    
</style>